import React, { useEffect } from "react";

import { Route, Switch, Redirect } from "react-router-dom";
import CompanyDetailsWrapper from "./CompanyDetailsForm/CompanyDetailsWrapper";
import NavbarContainer from "../../Navbar/NavbarContainer";
import SocialProfile from "./SocialProfile/SocialProfile";
import "./ProfileSetupWrapper.scss";
import { stepsCompleted } from "../../../actions/globalAction";
import { useDispatch, useSelector } from "react-redux";
import { formatTokenLists } from "../../../actions/utils";
import EasyQueryBuilder from "./NewQueryBuilder/EasyQueryBuilder";

const ProfileSetupWrapper = (props) => {
    const { company, isMobile } = props;
    const tokenLists = useSelector((state) => state.tokensReducer.tokenList);
    const formattedTokenLists = formatTokenLists(tokenLists);

    const dispatch = useDispatch();
    // const GAEventTracker = UseGAEventsTracker("New user SignUp");
    useEffect(() => {
        // GAEventTracker("SignUp step 2", `company-${company.company_identifier}`);
        if (company?.company_name && company?.industry && company?.is_profile_setup === 0) {
            dispatch(stepsCompleted("companyDetails"));
            props.history.push("/profile-setup/social-profiles");
        }
        if (Object.keys(formattedTokenLists).length > 0) {
            dispatch(stepsCompleted("socialProfile"));
        }
    }, []);

    return (
        <div className="wrapper">
            <NavbarContainer history={props.history} location={props.location} />
            {company.is_profile_setup === 1 && <Redirect to="/home" />}
            <Switch>
                <Route path="/profile-setup/company-details" render={(p) => <CompanyDetailsWrapper {...p} company={company} isMobile={isMobile} />} />
                <Route
                    path="/profile-setup/social-profiles"
                    render={(p) => {
                        return <SocialProfile {...p} isMobile={isMobile} company={company} />;
                    }}
                />
                <Route
                    path="/profile-setup/create-query"
                    render={(p) => {
                        return <EasyQueryBuilder {...p} isMobile={isMobile} />;
                    }}
                />
                <Redirect to="/profile-setup/company-details" />
            </Switch>
        </div>
    );
};

export default ProfileSetupWrapper;
